export default "__VITE_ASSET__DjSPzrjz__"